module.exports = __webpack_public_path__ + "img/paypal_logo.c42e92ba.png";